export default function InputLabel({ children, ...props }) {
  return (
    <label {...props} className="inline-block text-sm text-gray-700">
      {children}
    </label>
  )
}
